module.exports = __webpack_public_path__ + "img/blueJ_logo_blue.2667a93b.svg";